import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"transform":"scale(1.6)","margin-top":"50px"} }

import Nav from "./nav.vue";
import { onetThingSavePattrs, sendCode, sendCodeVerify } from "@/config/request";
import { ElMessage } from "element-plus";
import { nextTick, reactive, toRefs } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    publicData: Object
},
  setup(__props) {

const props = __props
const data = reactive({
    itemList:[],
})
const { publicData } = toRefs(props) as any
console.log('publicData::',publicData.value);



return (_ctx: any,_cache: any) => {
  const _component_el_result = _resolveComponent("el-result")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Nav),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_result, {
          icon: "success",
          "sub-title": "提交成功"
        })
      ])
    ])
  ], 64))
}
}

})